import React, { useEffect, useState } from "react";
import { Button, Image, Table } from "react-bootstrap";
import moment from "moment";
import BasicPagination from "../../../../Pagination/Pagination";
import ViewEvents from "./Events/ViewEvents";
import { NOTAVAILABLEIMAGE } from "../../../../../enums/GlobalEnums";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  create_and_update_restaurant,
  get_new_subscription_for_vendor,
} from "../../../../../store/actions/authAction";
import {
  PAYMENT_TYPE,
  PAYMENT_STATUS, NEW_PAYMENT_TYPE
} from "../../../../../enums/OrderEnums";
import { setVendorAccess } from "../../../../../store/actions/vendorAccessActions";
import NoContent from "../../../../reusableComponents/NoContentComponent";
import ViewExpReqDetails from "../../../../vendorDashboardComponents/Experiences/Experiencedashboard/ViewExpReqDetails";

const EventsPageComponent = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const [eventFilter, setEventFilter] = useState();

  let filteredData = props.data;
  //let filteredData = [];


  if (props.search) {
    filteredData = filteredData.filter((item) => {
      return (
        (item &&
          item.restaurant_id &&
          item.restaurant_id.restaurant_name &&
          item.restaurant_id.restaurant_name
            .toLowerCase()
            .includes(props.search.toLowerCase())) ||
        (item &&
          item.event_request_id &&
          item.event_request_id.includes(props.search)) ||
        (item &&
          item.transactional_id &&
          item.transactional_id.includes(props.search)) ||
        item?.name?.includes(props.search)
      );
    });
  }

  if (props.sortBy === "Latest") {
    filteredData = filteredData?.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );
  } else if (props.sortBy === "Oldest") {
    filteredData = filteredData?.sort(
      (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
    );
  } else if (props.sortBy === "A-Z") {
    filteredData = filteredData?.sort((a, b) =>
      a.restaurant_id?.restaurant_name > b.restaurant_id?.restaurant_name
        ? 1
        : -1
    );
  } else if (props.sortBy === "Z-A") {
    filteredData = filteredData?.sort((a, b) =>
      b.restaurant_id?.restaurant_name > a.restaurant_id?.restaurant_name
        ? 1
        : -1
    );
  }

  if (props.filterBy) {
    if (props?.filterBy?.status)
      filteredData = filteredData?.filter(
        (ele) => ele.event_status === props?.filterBy?.status
      );
    if (props?.filterBy?.eventType)
      filteredData = filteredData?.filter(
        (ele) => ele.event_type === props?.filterBy?.eventType
      );
  }

  if (eventFilter === 1) {
    filteredData = filteredData?.filter((ele) => ele.expType === "SPECIAL");
  } else if (eventFilter === 2) {
    filteredData = filteredData?.filter(
      (ele) => ele.expType === "CURATED"
    );
  } else {
    filteredData = filteredData;
  }
  // if (props.sortByDay !== 4) {
  //   filteredData = filteredData.filter((item) => {
  //     return (
  //       (props.startDay <= moment(item.createdAt).format("YYYY-MM-DD") ||
  //         props.startDay <= moment(item.updatedAt).format("YYYY-MM-DD")) &&
  //       (moment(item.createdAt).format("YYYY-MM-DD") <= props.endDay ||
  //         moment(item.updatedAt).format("YYYY-MM-DD") <= props.endDay)
  //     );
  //   });
  // }

  // if (props.startDate && props.endDate && props.clickedSearch) {
  //   let ed = new Date(props.endDate).getTime();
  //   let sd = new Date(props.startDate).getTime();

  //   filteredData = filteredData.filter((d) => {
  //     var time = new Date(d.createdAt).getTime();
  //     return sd < time && time < ed;
  //   });
  // }
  // useEffect(() => {
  //   if (props.data) {
  //     let sortedDates = [];

  //     if (props.sortByDate === 1) {
  //       sortedDates = props.data.sort(function (a, b) {
  //         return new Date(b.updatedAt) - new Date(a.updatedAt);
  //       });
  //     } else {
  //       sortedDates = props.data.sort(function (a, b) {
  //         return new Date(a.updatedAt) - new Date(b.updatedAt);
  //       });
  //     }
  //     setEvents(sortedDates);
  //   }
  // }, [props.data, props.sortByDate]);

  useEffect(() => {
    setPage(1);
    setStart(0);
    setEnd(10);
  }, [props.search]);

  const [insidePageTab, setinsidePageTab] = useState(10);
  // const [initialData, setinitData] = useState([]);
  const onClickSearch = (value) => {
    setinsidePageTab(value);
    let dataByType = [];
    if (value === 0) {
      dataByType = props.data.filter(function (a, b) {
        return a.event_type === "TICKET_BOOKED";
      });
    } else if (value === 1) {
      dataByType = props.data.filter(function (a, b) {
        return a.event_type === "RSVP";
      });
    } else {
      dataByType = props.data;
    }
    // setEvents(dataByType);
  };

  const [eventPageId, setEventPageId] = useState("");
  console.log("eventPageId", eventPageId);
  const onViewDashboard = () => {
    if (
      eventPageId !== undefined &&
      eventPageId !== null &&
      eventPageId !== ""
    ) {
      history.push({
        pathname: `/offline-events-details/${eventPageId && eventPageId}`,
        state: { offlineEventInformation: eventPageId && eventPageId },
      });
    }
  };

  const vendorDashboard = (vendorID, eventID) => () => {
    setEventPageId(eventID && eventID);
    dispatch(create_and_update_restaurant({ vendor_id: vendorID }));
    dispatch(get_new_subscription_for_vendor({ vendor_id: vendorID }));
    dispatch(setVendorAccess(vendorID, onViewDashboard));
  };
  // const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  // const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });


  return (
    <React.Fragment>
      <div className="row super_admin_all_users_toggle_button-tab">
        <div className="col-9 super_admin_all_users_toggle_button-tab">
          <div className="Right-side-heading-text ml-0">
            <div className="d-flex align-items-center">
              <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${eventFilter === 10 ? "active" : ""
                  }`}
                onClick={() => {
                  // props.onChangeOrderState("order_type", 10);
                  // onClickSearch(10);
                  setEventFilter(10);
                }}
              >
                All
              </Button>
              <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${eventFilter === 1 ? "active" : ""
                  }`}
                onClick={() => {
                  // props.onChangeOrderState("order_type", 0);
                  // onClickSearch(1);
                  setEventFilter(1);
                }}
              >
                special
              </Button>
              <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${eventFilter === 0 ? "active" : ""
                  }`}
                onClick={() => {
                  // props.onChangeOrderState("order_type", 2);
                  // onClickSearch(0);
                  setEventFilter(2);
                }}
              >
                Curated
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 p-0 user-table-reusable-superadmin table-responsive ">
        <Table className="enMinWidth900">
          <thead>
            <tr className="super_admin_all_users_table_head">
              <td style={{ width: "10%" }} className="f12-400">
                Experience Type/
                <br />Ticket No.
              </td>
              <td style={{ width: "10%" }} className="f12-400">
                Restaurant
                <br /> Name
              </td>
              <td style={{ width: "15%" }} className="f12-400">
                My Experience
              </td>
              <td style={{ width: "10%" }} className="f12-400">
                Amount /<br /> Payment
              </td>
              <td style={{ width: "10%" }} className="f12-400">
                Total PAX
              </td>
              <td style={{ width: "10%" }} className="f12-400">
                Status
              </td>
              <td style={{ width: "10%" }} className="f12-400">
                Date/Time
              </td>
              <td style={{ width: "15%" }} className="f12-400" >
                Actions
              </td>
            </tr>
          </thead>

          {filteredData?.length ?
            filteredData
              .slice(start, end)
              .map((exp, index) => <TableBody key={index} exp={exp} />) : <NoContent />}

        </Table>
        {filteredData.length !== 0 ? (
          <BasicPagination
            totalRecords={filteredData.length}
            limit={10}
            batch={page}
            onBatchChange={(e) => handleBatchChange(e)}
          />
        ) : (
          <></>
        )}
      </div>
    </React.Fragment>
  );
};

const TableBody = ({ key, exp, vendorDashboard }) => {
  const [TrDetail, setTrDetail] = useState(false);
  const showTr = () => setTrDetail(!TrDetail);


  const totalpaxvalue = () => {
    let value = 0;
    if (exp?.package?.count < 1) {
      value = ((exp?.adultCount || 0) + (exp?.kidsCount || 0));
      return value
    } else {
      value = ((exp?.adultCount || 0) + (exp?.kidsCount || 0)) + ((exp?.package?.adults + exp?.package?.kids))
      return value
    }
  }


  const [waitData, setWaitData] = useState({ waitTime: exp.waitTime, waitTimeDate: exp.waitTimeDate });

  const updatedTime = new Date(
    exp?.status === 'PENDING' ? waitData?.waitTimeDate : exp?.reservationTime
  );


  const currentTimeTwo = new Date().getTime();
  const updatedTimeNew = updatedTime.getTime();
  const waitTime = waitData?.waitTime * 60 * 1000 || 0;
  let updateWaitTime = updatedTimeNew + waitTime;
  let diff = updateWaitTime - currentTimeTwo;

  const endTime = moment().valueOf();
  const startTime = moment(exp?.createdAt).valueOf();

  let msDifference = endTime - startTime;
  let minutes = Math.floor(msDifference / 1000 / 60);

  function timeConvert(minutes) {
    var hours = Math.floor(minutes / 60);
    var nMinutes = minutes % 60;
    return hours + " HH : " + nMinutes + " min";
  }
  return (
    <>
      <tbody>
        <tr className="super_admin_all_users_table_body">
          <td className="p-0 w-100">
            <table className="w-100 HideShowTable">
              <tbody>
                <tr
                  className="cursor super_admin_user_view_inside_table_body"
                  onClick={showTr}
                  key={key}
                >
                  <td style={{ width: "10%" }}>
                    {/* <div className="d-flex align-items-center mb-3">
                      {event.event_type === "RSVP" ? (
                        <Image
                          src={require("../../../../../assets/images/seatingImages/happy-new-year.svg")}
                          alt="Order Type"
                          title="Order Type"
                          className="img-fluid"
                        />
                      ) : null || event.event_type === "TICKET_BOOKED" ? (
                        <Image
                          src={require("../../../../../assets/images/seatingImages/movie-seat.svg")}
                          alt="Order Type"
                          title="Order Type"
                          className="img-fluid"
                          style={{ width: 28 }}
                        />
                      ) : null}
                      <h5 className="f14-500 ml-2">
                        {event.event_type === "TICKET_BOOKED"
                          ? "Ticketed"
                          : "RSVP"}
                      </h5>
                    </div> */}
                    <p className="f12-500">#{exp.expType}</p>
                    <p className="f9-500">#{exp.requestId}</p>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="align-items-center" align="center">
                      <div>
                        <Image
                          //src={require("../../../../../assets/images/UserManagement/fhr7.png")}
                          src={
                            (exp?.restaurantId.logo_url) ||
                            NOTAVAILABLEIMAGE
                          }
                          alt="restaurant logo"
                          title="restaurant logo"
                          className="enIMG28Round"
                        />
                      </div>
                      <div className="pl-2 mt-2">
                        <div className="f11-500">
                          {" "}
                          {exp?.restaurantId?.restaurant_name}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "15%" }}>
                    <div className="align-items-center">
                      <div className="d-flex">
                        <Image
                          //src={require("../../../../../assets/images/UserManagement/fhr7.png")}
                          src={
                            (exp?.experienceId?.photos[0]) ||
                            NOTAVAILABLEIMAGE
                          }
                          alt="event pic"
                          title="event pic"
                          className="enIMG28Round"
                        />
                        <div className="pt-3 ml-2 f12-500">
                          {exp?.experienceId?.name}
                          {exp?.experienceId?.expId}
                        </div>
                      </div>
                      {/* <div
                        className="badge badge-warning mt-2 f10-400 px-2 py-1"
                        style={{ borderRadius: 50 }}
                      >
                        
                      </div> */}
                    </div>
                  </td>
                  <td className="text-center"
                    style={{
                      width: "10%",
                    }}
                  >
                    <span className="f12-500 d-flex align-items-center justify-content-center">
                      <i className="fa fa-inr mr-1" aria-hidden="true"></i>
                      {exp?.paymentStatus === 1 ? (
                        <div className="d-flex ml-1 align-items-center">
                          {exp?.paymentData?.totalAmount}{" "}
                          |{" "}
                          <div
                            className=" f10-500 ml-1"
                            style={{ color: exp?.paymentStatus === 1 ? "#3E9121" : "#EE3A23" }}
                          >
                            {exp?.paymentStatus === 1
                              ? "PAID"
                              : exp?.paymentStatus === 0
                                ? "UNPAID"
                                : exp?.paymentStatus === 3
                                  ? "FAILURE"
                                  : "N/A"}
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </span>
                    <hr className="my-1" />
                    {exp.paymentStatus !== 1 ? (
                      exp.status === "CANCELLED" ? (
                        ""
                      ) : (
                        <div className="mt-1 mb-1 text-center">
                          <button
                            className="btn bg-danger text-white f10-400 px-2 py-1"
                            onClick={() => { }
                              // onClickPayLater(props.orderDetails)
                            }
                          >
                            Pay Now
                          </button>
                        </div>
                      )
                    ) : (
                      ""
                    )}
                    <div className="text-center">
                      <div className="f12-500">
                        {exp?.splitPayment ? (
                          <>Split Payment</>
                        ) : (NEW_PAYMENT_TYPE[exp.paymentData?.paymentMethod])}
                      </div>
                    </div>
                  </td>

                  <td style={{ width: "10%" }} className="">
                    <div className="total-pax-body">
                      <div className="col d-flex justify-content-start p-0">
                        <div className="total-pax-body-inside px-2">
                          <p className="font_24_b">
                            {((exp?.adultCount || 0) + (exp?.kidsCount || 0)) + ((exp?.package?.adults + exp?.package?.kids))}
                          </p>
                        </div>
                        <div className="total-adult-kids">
                          {exp?.adultCount + exp.package.adults === 0 ? null : (
                            <div className="display-align">
                              <Image
                                src={require("../../../../../assets/images/ActionImages/image/adult.svg")}
                                alt="Adult"
                                title="Adult"
                                className="pax-type-Image"
                              />
                              <p className="font_12_m ml-1 mr-1">
                                {exp?.adultCount + exp.package.adults * exp?.package.count}
                              </p>
                            </div>
                          )}
                          {exp?.kidsCount + exp.package.kids * exp.package.count > 0 ? (
                            <div className="display-align">
                              <Image
                                src={require("../../../../../assets/images/ActionImages/image/kids.svg")}
                                alt="Kids"
                                title="Kids"
                                className="pax-type-Image"
                              />
                              <p className="font_12_m ml-1 mr-1">
                                {exp?.kidsCount + exp.package.kids * exp.package.count}
                              </p>
                            </div>
                          ) : null}
                        </div>
                        <div className="total-highchair-handicapp">
                          {exp?.highchairCount === 0 ? null : (
                            <div className="display-align">
                              <Image
                                src={require("../../../../../assets/images/ActionImages/image/highchair.svg")}
                                alt="Highchair"
                                title="Highchair"
                                className="pax-type-Image"
                              />
                              <p className="font_12_m ml-1 mr-1">
                                {exp?.highchairCount}
                              </p>
                            </div>
                          )}
                          {exp?.handicapCount === 0 ? null : (
                            <div className="display-align">
                              <Image
                                src={require("../../../../../assets/images/ActionImages/image/handicap.svg")}
                                alt="Handicapped"
                                title="Handicapped"
                                className="pax-type-Image"
                              />
                              <p className="font_12_m ml-1 mr-1">
                                {exp?.handicapCount}
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="f12-400">
                      <span
                        className={`${exp?.status ===
                          "REJECTED"
                          ? "enYellowDot"
                          : exp?.status === "NOTSEATED"
                            ? "enYellowDot"
                            : exp?.status === "PENDING"
                              ? "enYellowDot"
                              : exp?.status === "CANCELLED"
                                ? "enRedDot"
                                : exp?.status === "SEATED"
                                  ? "enGreenDot"
                                  : "enDarkGreenDot"
                          } mr-1`}
                      ></span>
                      {exp && exp?.status}
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="f12-400">
                      {" "}
                      {moment(exp?.createdAt).format("DD MMM YYYY")}
                    </div>
                    <div className="f12-700">
                      {" "}
                      {moment(exp?.createdAt).format("LT")}
                    </div>
                  </td>

                  <td style={{ width: "15%" }}>
                    <div className="enWidth130 d-flex align-items-center">
                      <ViewExpReqDetails dataSend={exp} diff={diff} twt={timeConvert(minutes)} />{" "}

                      {/* justify-content-end flex-wrap  */}
                      {/* <Button
            variant="link"
            className="enIconBtn mr-2 mb-2"
            // onClick={handleShowEdit}
          >
            <Image
              src={require("../../../../../assets/images/UserManagement/pencil.svg")}
              alt="View"
              title="Edit User"
              fluid
            />
          </Button> */}
                      {/* <ViewEvents userData={event} /> */}
                      {/* <Button
                        variant="link"
                        className="enIconBtn mr-2 mb-2"
                        onClick={vendorDashboard(
                          event?.vendor_id,
                          event?.event_id?._id
                        )}
                      >
                        <Image
                          src={require("../../../../../assets/images/UserManagement/pencil.svg")}
                          alt="View"
                          title="Edit User"
                          fluid
                        />
                      </Button> */}
                    </div>
                  </td>
                </tr>
                {TrDetail && (
                  <tr className="border-top">
                    <td width="15%">
                      <div className="f12-700 mb-2">Seating preferences</div>
                      <div className="f12-500">
                        {exp?.seatingPreference.length && exp?.seatingPreference[0]}
                      </div>
                      {/* <div className="f11-400">Room No. {event?.room_number}</div> */}
                    </td>
                    <td width="15%">
                      <div className="f12-700 mb-2">Special occasion</div>
                      <div className="f12-500"> {exp?.occasion || 'N/A'}</div>
                      {/* <div className="f11-400">
            {props && props.seating && props.seating.occasion}
          </div> */}
                    </td>
                    {exp?.status === "CANCELLED" ||
                      exp?.status === "REJECTED" ? (
                      <> </>
                    ) : (
                      <td width="15%" align="center">
                        <div className="f15-700 mb-2">Total wait time</div>
                        <div className="px-2" align="center">
                          <div className="enTimesLbl d-flex justify-content-center align-items-center">
                            <Image
                              src={require("../../../../../assets/images/UserManagement/hourglass.svg")}
                              alt="Edit"
                              title="Edit"
                              width="10px"
                            />
                            <p className="f10-500 text-dark pl-2">
                              {timeConvert(minutes) || "00 hh : 00 min"}
                            </p>
                          </div>
                        </div>
                      </td>
                    )}
                  </tr>
                )}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </>
  );
};

export default EventsPageComponent;
